import PropTypes from "prop-types"
import React, { Component } from "react"
import './styles.css'

class Notification extends Component {

  shouldComponentUpdate() {
    return false
  }

  render() {

    let log
    switch (this.props.type) {
    case 'error':
      log = 'danger'
      break
    case 'info':
      log = 'success'
      break
    default:
      log = 'info'
      break
    }

    let className = `alert alert-${log} alert-dismissible fade show`

    return (<div className={className} role="alert">
      {this.props.title && <strong className="alert-heading">{this.props.title}</strong>}
      {this.props.text}
      <button type="button" onClick={this.props.onDismissClick} className="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>)
  }
}

Notification.propTypes = {
  color: PropTypes.string.isRequired,
  onDismissClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
  type: PropTypes.string
}

export default Notification


// WEBPACK FOOTER //
// ./src/components/notifications/notification.js